import { DocumentCornSchema } from '@eigtech/documents-types';
import { TemplateCornSchema } from '@eigtech/templates-types';
import { z } from 'zod';
import { ProcessingStateSchema } from './processing.js';
import { GuidedDocumentTemplateSchema } from './guidedDocument.js';
export const DraftDocumentStateSchema = z.enum([
    'pending', // 1
    'readingTemplate', // 2
    'gatheringData', // 3
    'buildingDocument', // 4
    'recordingResults', // 5
    'complete', // 6
    'error', // X
]);
export const DraftDocumentRecordSchema = ProcessingStateSchema.extend({
    draftDocumentId: DocumentCornSchema.optional(),
    guidance: z
        .record(z.string(), z.object({
        confidence: z.number().optional(),
        evidence: z.string().optional(),
        response: z.string(),
    }))
        .optional(),
    guidedDocumentTemplate: GuidedDocumentTemplateSchema.optional(),
    state: DraftDocumentStateSchema,
    templateId: TemplateCornSchema,
});
